import axios from '@/axios'

const state = {
  collectionSingle: undefined,
  error: undefined,
  loading: false,
  users: [],
  dataSuccess:undefined,
  price:[]
};
const actions = {
  async save({commit}, payload) {
    try {
      commit('LOADING', true);
      if (payload.id) {
        await axios({
          method: 'put',
          url: 'admin/price/'+payload.id,
          data: {...payload}
        })
      } else {
        await axios({
          method: 'post',
          url: 'admin/price',
          data: payload
        })
      }

    } catch (e) {
      console.log('error has')
      commit('ERROR', e);
      throw e
    } finally {
      commit('LOADING', false);
    }
  },

  async priceId({commit}, id) {
    try {
      commit('LOADING', true);
      let res = await axios.get('admin/price/' + id);
      console.log(res.data, 'res-attr');
      commit('PRICE_ID', res.data);
    } catch (e) {
      commit('ERROR', e);
      throw e;
    } finally {
      commit('LOADING', false);
    }
  },


};
const mutations = {
  UPDATE_PRICE(state, payload) {
    state.priceEdit = state.priceEdit.map(price => {
      if (price.id === payload.id) {
        return Object.assign({}, price, payload.data)
      }
      return price
    })
    console.log(state.adv, 'users data kole')
  },

  INIT(state, data) {
    state.price = data;
  },

  LOADING(state, payload) {
    state.loading = payload;
  },
  PRICE_ID(state, payload) {
    state.collectionSingle = payload;
  },
  DATA_SUCCESS(state,payload){
    state.dataSuccess = payload
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
